import {
    FormattedVerificationTransactionDetails,
    VerificationTransactionDetails
} from "@idw-types/data/verification-transaction-details";
import { AxnRelyingParty, AxnTransactionType, AxnSelectedServiceOfferingSO, AxnAttributeType, AxnCountry } from "@idw-types/data/reference-data/axn";
import { Assertion } from "@idw-types/data/reference-data/generic";
import { formatVerificationTransactionDetailsPolicyDecisions } from "./verification-transaction-details-policy-decision-formatter";
import { formatVerificationTransactionDetailsClaims } from "./verification-transaction-details-claim-formatter";
import { formatVerificationTransactionDetailsTransactionEvents } from "./verification-transaction-details-transaction-event-formatter";
import { formatVerificationTransactionDetailsScores } from "./verification-transaction-details-score-formatter";
import { formatVerificationTransactionDetailsTrustScoreModifiers } from "./verification-transaction-details-trust-score-modifier-formatter";
import { formatVerificationTransactionDetailsTrustScoreInputs } from "./verification-transaction-details-trust-score-input-formatter";
import { formatVerificationTransactionDetailsAssertionScoreModifiers } from "./verification-transaction-details-assertion-score-modifier-formatter";
import { formatVerificationTransactionDetailsAssertionScoreBreakdowns } from "./verification-transaction-details-assertion-score-breakdown-formatter";
import { formatVerificationTransactionDetailsTrustScoreBreakdowns } from "./verification-transaction-details-trust-score-breakdown-formatter";
import { mapCountryToSelectOption } from "@utils/select-option-mapping-util";

export const formatVerificationTransactionDetails = (
    verificationTransactionDetails: VerificationTransactionDetails,
    relyingParties: Array<AxnRelyingParty>,
    transactionTypes: Array<AxnTransactionType>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>,
    attributeTypes: Array<AxnAttributeType>,
    assertions: Array<Assertion>,
    axnCountries: Array<AxnCountry>
): FormattedVerificationTransactionDetails => {
    const relyingParty = relyingParties.find(rp => rp.id === verificationTransactionDetails.relyingParty);
    const axnCountry = axnCountries.find(ac => ac.alpha2 === verificationTransactionDetails.country);

    let formattedCountry: string;
    if (axnCountry) {
        formattedCountry = mapCountryToSelectOption(axnCountry).label;
    }

    const transactionEvents = formatVerificationTransactionDetailsTransactionEvents(
        verificationTransactionDetails.transactionEvents,
        transactionTypes,
        axnSelectedServiceOfferingSOs,
        attributeTypes
    );

    return {
        apiKey: verificationTransactionDetails.apiKey,
        appID: verificationTransactionDetails.appID,
        asi: verificationTransactionDetails.asi,
        assertionScoreBreakdowns: formatVerificationTransactionDetailsAssertionScoreBreakdowns(verificationTransactionDetails.assertionScoreBreakdowns),
        assertionScoreModifiers: formatVerificationTransactionDetailsAssertionScoreModifiers(
            verificationTransactionDetails.assertionScoreModifiers,
            assertions,
            axnSelectedServiceOfferingSOs
        ),
        claims: formatVerificationTransactionDetailsClaims(verificationTransactionDetails.claims),
        country: formattedCountry,
        credential: verificationTransactionDetails.credential,
        mbun: verificationTransactionDetails.mbun,
        policyDecisions: formatVerificationTransactionDetailsPolicyDecisions(verificationTransactionDetails.policyDecisions),
        relyingParty: relyingParty,
        scores: formatVerificationTransactionDetailsScores(verificationTransactionDetails.scores),
        serviceName: verificationTransactionDetails.serviceName,
        sessionKey: verificationTransactionDetails.sessionKey,
        summary: verificationTransactionDetails.summary,
        transactionEvents: transactionEvents,
        trustScoreBreakdowns: formatVerificationTransactionDetailsTrustScoreBreakdowns(verificationTransactionDetails.trustScoreBreakdowns),
        trustScoreInputs: formatVerificationTransactionDetailsTrustScoreInputs(verificationTransactionDetails.trustScoreInputs, attributeTypes),
        trustScoreModifiers: formatVerificationTransactionDetailsTrustScoreModifiers(
            verificationTransactionDetails.trustScoreModifiers,
            assertions,
            axnSelectedServiceOfferingSOs
        ),
        workflow: verificationTransactionDetails.workflow
    };
};